module.exports = __webpack_public_path__ + "static/img/npgk.2cfe765.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/slider/npgk.png
// module id = 83
// module chunks = 0